import { MplexStreamMuxer } from './mplex.js';
class Mplex {
    constructor(init = {}) {
        this.protocol = '/mplex/6.7.0';
        this._init = init;
    }
    createStreamMuxer(init = {}) {
        return new MplexStreamMuxer({
            ...init,
            ...this._init
        });
    }
}
export function mplex(init = {}) {
    return () => new Mplex(init);
}
